/**
 * Email validation function
 * I stole this regex from here: https://mailtrap.io/blog/angular-email-validation/
 */
export function emailAddressIsValid(candidate: string): boolean {
  return !!candidate.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,30}$/)
}

/** Mirrors the AWS StackSet name rule. Empty returns null so the field can be filled in later. */
export function getStackSetNameError(name: string): string | null {
  if (!name) return null

  if (name.length > 128) return 'Must be 128 characters or fewer.'

  if (!/^[a-zA-Z][a-zA-Z0-9-]*$/.test(name))
    return 'Must start with a letter and contain only letters, numbers, and hyphens.'

  return null
}
